import { render, staticRenderFns } from "./UpdateSamTask.vue?vue&type=template&id=1dac7fe6"
import script from "./UpdateSamTask.vue?vue&type=script&lang=js"
export * from "./UpdateSamTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports